import React, { useState } from "react";
// import ReactEcharts from "echarts-for-react";
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import {
    PieChart
} from 'echarts/charts';
import {
    LegendComponent
} from 'echarts/components';
echarts.use(
    [LegendComponent, PieChart]
);
const MapLegend = ({
    lineageList,
    colorRange
}) => {    
    const [loading, setLoading]=useState(true)
    const [pieChartData,setPieChartData]=useState([])
    // const [legendData,setLegendData]=useState([])
    React.useEffect(() => {
        if (colorRange&&colorRange.length>0&&lineageList.length>0 && colorRange.length>0) {
            // let maxName=lineageList.reduce((a, b) => Math.max(a.length, b.length), -Infinity);
            // setLegendData(lineageList.map(item=>{return  item.padEnd(10,'_')}))
            // console.debug(maxName,legendData)
            setPieChartData(lineageList.map(item=>{return {name: item,value:1}}))
            setLoading(false)
        }else
            setLoading(true)
    }, [lineageList, colorRange])
    const option = {
        legend: {
            orient: 'horizontal',
            // left: '50%',
            // right: '4%',
            icon: 'circle',
            data: lineageList,
            textStyle: {
                fontSize: 10,
                // width: 50
            },
            align:'left',
            itemWidth: 15,
            itemGap: 5,
            itemStyle:{
                align: 'center'
            }
        },
        series: [
            {
                type: 'pie',
                data: pieChartData,
                width: '0%',
                label: {
                    show: false
                },
                color: colorRange
            }
        ],
        // color: genotypeColorsArray
    };

    return (<>
        {/* <text>Test</text> */}
        <ReactEChartsCore loading={loading} echarts={echarts} option={option} style={{ height: 80 }} />
    </>
    );
};

export default MapLegend;
